export const capitalize = (value: string): string =>
  value &&
  value
    .replace(/ +(?= )/g, '')
    .toLowerCase()
    .split(' ')
    .filter((string) => string)
    .map((str) => str[0].toUpperCase() + str.substring(1))
    .join(' ');
